import uFuzzy from "@leeoniya/ufuzzy"

const parseSearchInput = (search: string) => {
  // Search can container ~anything like html and whatnot
  try {
    const parsedInput = new DOMParser().parseFromString(search, "text/html")
    // Parse search term from possible html
    const nonHtmlContent = parsedInput.body.textContent?.trim() ?? ""

    // Remove characters we never include in project names or urls and which can't be translated (* and \) and swap _ to space
    return nonHtmlContent.replace(/\*|\\/g, "").replace(/_/g, " ")
  } catch (e) {
    // server side fails
    return search
  }
}

const fuzzyOptions: uFuzzy.Options = {
  intraMode: 1,
  intraSub: 1,
  intraTrn: 1,
  intraDel: 1,
  intraIns: 1,
}

const uf = new uFuzzy(fuzzyOptions)

interface SearchSegment<T extends unknown> {
  items: Array<T>
  tags?: string[]
  keys: Array<keyof T>
}

export const filterItems = <T extends unknown>(
  { items, keys, tags }: SearchSegment<T>,
  rawSearchTerm: string
): T[] => {
  const searchTerm = parseSearchInput(rawSearchTerm)
  const haystack: string[] = []

  // Constract haystack
  for (let i = 0, m = items.length; i < m; i++) {
    const obj = items[i]
    let straws = keys
      // Take all requested keys into account
      .map<string>((key) => {
        const keyValue = obj[key]
        if (typeof keyValue !== "string") {
          // Mainly for types because not verified by types
          console.warn(
            `Incorrect usage of keys when filtering. Key should match to string. Was of type ${typeof keyValue}`
          )
          return ""
        }
        return keyValue
      })

    if (tags) {
      // Join with static tags like "metric" or "project"
      straws = straws.concat(tags)
    }

    haystack.push(straws.filter(Boolean).join(" "))
  }

  const [filteredIndexes, info, order] = uf.search(haystack, searchTerm, true)

  if (!filteredIndexes?.length || !info || !order) {
    // Nothing found or could not search with the term
    return []
  }

  const results = []
  // render post-filtered & ordered matches
  for (let i = 0, n = order.length; i < n; i++) {
    // using info.idx here instead of idxs because uf.info() may have
    // further reduced the initial idxs based on prefix/suffix rules
    results.push(items[info.idx[order[i]]])
  }

  return results
}
